<template>
  <section>
    <div class="container">
      <!-- row -->
      <div class="row">
        <div class="col-md-12 col-sm-12" style="padding-bottom:10px;">
          <h3>{{ job.title.name }}</h3>
          <h4>{{ job.company_desc ? job.company_desc : job.client_company.name.name }} <span class="skill-tag" v-if="job.featured">{{ $t('jobs.featured') }}</span></h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-sm-6">
          <div class="sidebar">
          
            <!-- Start: Opening hour -->
            <div class="widget-boxed">
              <div class="widget-boxed-body">
                <a href="javascript:void(0)" class="btn btn-m theme-btn full-width mrg-bot-10" style="width:100%" @click="applyJob(job.id)"><i class="fa fa-paper-plane"></i>{{ $t('job-detail.apply') }}</a>
                <a class="btn btn-m light-gray-btn full-width" @click="showShare = !showShare"><i class="fa fa-share-alt"></i>{{ $t('job-detail.share') }}</a>
                <div v-if="showShare" style="margin-top:20px">
                  <Share :config="config" />
                </div>
              </div>
            </div>
            <!-- End: Opening hour -->
            
            <!-- Start: Job Overview -->
            <div class="widget-boxed">
              <div class="widget-boxed-header">
                <h4><i class="fa fa-info-circle padd-r-10"></i>{{ $t('job-detail.info') }}</h4>
              </div>
              <div class="widget-boxed-body">
                <div class="side-list no-border">
                  <img :src="jobImg" class="avatar avatar-lg" alt="Avatar" v-if="jobImg">
                  <h5>{{ $t('job-detail.function') }}</h5>
                  <p>{{ $i18n.locale === 'zh' ? job.job_function.c_fullname : job.job_function.e_fullname }}</p>
                  <!--<h5>{{ $t('job-detail.industry') }}</h5>
                  <p>互联网</p>-->
                  <h5 v-if="job.required_experience">{{ $t('job-detail.work-length') }}</h5>
                  <p v-if="job.required_experience">{{ workExp }}</p>
                  <h5>招聘人数</h5>
                  <p>{{ job.head_count > 1 ? job.head_count + '人' : '未知' }}</p>
                  <!--<h5 v-if="job.tags.length > 0">职位亮点</h5>-->
                  <p v-if="job.tags.length > 0">{{ tags }}</p>
                  <h5 v-if="job.internFlag"><i class="icon-51job" style="margin:0 auto;width:28px;height:28px"></i>该职位由实习生基地提供</h5>
                  <h5 v-if="job.isMagex"><i class="icon-magex" style="margin:0 auto;width:28px;height:28px"></i>该职位来自ACCA全球职位公告板</h5>
                  <h5 v-else-if="job.config">该职位来自{{ job.config.feed_name }}</h5>
                  <p class="theme-cl mrg-bot-0 mrg-top-10">ACCA职业公告版优先推荐ACCA人才</p> 
                </div>
              </div>
            </div>
            <!-- End: Job Overview -->
            
            <!-- Start: Contact Consultant -->
            <!-- End: Contact Consultant -->
          </div>
        </div>
        <div class="col-md-7 col-sm-6">
          <div class="detail-wrapper">
            <div class="detail-wrapper-body">
              <div class="job-title-bar side-list">
                <ul class="category-list">
                  <li><i class="ti-location-pin padd-r-10"></i>{{ $t('job-detail.location') }} <span class="">{{ job.work_location !=null ? job.work_location.c_fullname : '' }}</span></li>
                  <li><i class="ti-timer padd-r-10"></i>{{ $t('job-detail.open-date') }} <span class="">{{ job.create_at | dateFormat('from', $i18n.locale) }}</span></li>
                  <li><i class="ti-money padd-r-10"></i>{{ $t('job-detail.salary-range') }} <span class="">{{ salary }}</span></li>
                  <li><i class="ti-menu padd-r-10"></i>{{ $t('job-detail.job-type') }} <span class="">{{ jobType }}</span></li>
                </ul>
              </div>
            </div>
          </div>
          
          <div class="detail-wrapper" v-if="job.highlight">
            <div class="detail-wrapper-header">
              <h4>{{ $t('job-detail.summary') }}</h4>
            </div>
            <div class="detail-wrapper-body" v-html="summary">
            </div>
          </div>
          
          <div class="detail-wrapper" v-if="job.responsibility">
            <div class="detail-wrapper-header">
              <h4><i class="fa fa-comment-o" /> {{ $t('job-detail.responsibility') }}</h4>
            </div>
            <div class="detail-wrapper-body" v-html="responsibility">
            </div>
          </div>
          
          <div class="detail-wrapper" v-if="job.requirements">
            <div class="detail-wrapper-header">
              <h4><i class="fa fa-thumbs-up" /> {{ $t('job-detail.requirement') }}</h4>
            </div>
            <div class="detail-wrapper-body" v-html="requirement">
            </div>
          </div>

          <div class="detail-wrapper" v-if="job.client_company">
            <div class="detail-wrapper-header">
              <h4><i class="fa fa-building" /> {{ $t('job-detail.company') }}</h4>
            </div>
            <div class="detail-wrapper-body">
              <p>{{ job.client_company.name.name }}<br>
                <span v-for="(industry, index) in job.client_company.industries" :key="index">
                  {{ industry.c_fullname }}; 
                </span>
              </p>
              <p>
                <span v-if="job.client_company.company_size">{{ $t('job-detail.company-size') }}: {{ companySize[job.client_company.company_size] }}</span>
                <span v-if="job.client_company.company_type"><br />{{ $t('job-detail.company-type') }}: {{ companyType[job.client_company.company_type] }}</span>
                <span v-if="job.client_company.website"><br />{{ $t('job-detail.website') }}: {{ job.client_company.website }}</span>
              </p>
              <p v-if="job.client_company.description != null" v-html="job.client_company.description"></p>
            </div>
          </div>
          
        </div>
        <div class="col-md-2 col-sm-12">
          <SideAds />
        </div>
        
      </div>
      <!-- End Row -->
      
      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <h4 class="mrg-bot-20">{{ $t('job-detail.more') }}</h4>
        </div>
      </div>
      <!-- End Row -->
      
      <!-- row -->
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <table class="table table-lg table-hover job-title" style="table-layout:fixed">
            <!--<thead>
              <tr>
                <th>{{ $t('join.job-title') }}</th>
                <th>{{ $t('join.location') }}</th>
                <th>{{ $t('join.open-date') }}</th>
                <th>&nbsp;</th>
              </tr>
            </thead>-->
            <tbody>
              <tr v-for="job in jobs" :key="job.data.id">
                <td width="45%">
                <!--<router-link :to="/jobs/ + job.data.id">-->
                  <img :src="job.data.recruiting_company.photo_url" class="avatar avatar-lg" alt="Avatar" style="float:left"><p class="elli">{{ job.data.title.name }}<br><span class="mng-jb1">{{ job.data.company_desc || job.data.recruiting_company.name.name }}</span><br>
                  <span class="skill-tag" v-if="job.data.featured">{{ $t('jobs.featured') }}</span><span class="new" v-if="isNew(job.data.create_at)">&nbsp;New</span>
                  </p>
                  
                  
                <!--</router-link>-->
                
              </td>
              <td><i class="ti-location-pin"></i> {{ $i18n.locale === 'zh' ? job.data.work_location.c_fullname : job.data.work_location.e_fullname }}</td>
              <td>{{ job.data.create_at | dateFormat1('from', $i18n.locale) }}</td>
              <td :class="{'isintern': job.data.internFlag, 'ismagex': job.data.isMagex}" :style="jobListRowStyle(job.data.config)">
                <router-link :to="'/jobs/' + job.data.id" data-toggle="modal" data-target="" class="btn theme-btn-outlined mrg-5">{{ $t('jobs.apply') }}</router-link>
              </td>  
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- End Row -->
      
    </div>

    <div class="modal fade" id="apply-by-email-hint" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">温馨提示
            <button type="button" class="close" data-dismiss="modal">
              <h4>&times;</h4>
            </button>
            </h4>
          </div>
          <div class="modal-body">
            <div class="mrg-15">
              <p>在撰写给HR的邮件时，记住以下几点小技巧，可以大大增加您的求职成功率：</p>
              <ol style="padding-left:20px;">
                <li><b>个性化开场白：</b>用HR的姓名开头，并简短介绍自己，让邮件显得更加亲切和专业。</li>
                <li><b>明确表达兴趣：</b>直接说明您对该职位的兴趣，以及您是如何了解到这个招聘信息的。这能让HR感受到您的诚意和积极性。</li>
                <li><b>突出核心优势：</b>在邮件正文中简要概述您的核心技能和成就，特别是与应聘职位直接相关的部分。用具体事例来支撑您的能力，这样更有说服力。</li>
                <li><b>展现热情与匹配度：</b>谈谈您对公司的了解，以及您为何认为自己是这个职位的最佳人选。表达您对加入公司的渴望，以及您能为公司带来的价值。</li>
                <li><b>呼吁行动：</b>在邮件结尾处，明确请求一个面试机会。这可以让HR知道您的下一步期望，也增加了他们回复的可能性。</li>
                <li><b>保持简洁明了：</b>虽然您想展示自己，但也要确保邮件内容简洁明了，避免冗长和离题。HR通常时间有限，他们更倾向于阅读简短而有力的邮件。</li>
                <li><b>检查语法与拼写：</b>在发送前务必仔细检查邮件中的语法和拼写错误。一个整洁、无误的邮件能给HR留下良好的第一印象。</li>
              </ol>
              <p>记住，邮件正文是您向HR展示个性和职业态度的绝佳机会。用心撰写，让您的求职之路更加顺畅！</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style>
span.new {
  color: #d81c00;
}
#apply-by-email-hint {
 z-index: 1100;
}
</style>
<script>

import moment from 'moment'
//import JobBox from '@/components/JobBox.vue'
//import MessageForm from '@/components/detail/MessageForm.vue'
import Share from 'vue-social-share'
import SideAds from '@/components/SideAds.vue'
import jobStyle from '@/utils/job-style'

export default {
  name: 'JobDetail',
  props: ['job', 'jobs'],
  components: {
    SideAds,
    Share
  },
  data: () => ({
  showShare: false
  }),
  computed: {
    isLogedIn: function() {
      return this.$store.state.user != null
    },
    loginUrl: function() {
      let url = this.API_PREFIX + '/api/acca/signin?redirect_url=' + encodeURIComponent(location.href)
      return url
    },
    displayResumeStatus: function() {
      let n = this.$t('nav.edit-profile')
      if (!this.$store.state.myResume)
        n = this.$t('nav.create-profile')
      return n
    },
    config: function() {
      return {
        title: this.job.title.name,
        description: this.job.company_desc,
        disabled: ['google', 'facebook', 'twitter', 'diandian', 'linkedin', 'tencent'], // 禁用的站点
        wechatQrcodeTitle: this.$t('job-detail.wechat'),
        wechatQrcodeHelper: ''
      }
    },
    salary: function() {
      return this.salaryLabel(this.job.salary_from, this.job.salary_to, this.job.salary_negotiable)
    },
    summary: function() {
      return this.itemize(this.job.highlight)
    },
    responsibility: function() {
      return this.itemize(this.job.responsibility)
    },
    requirement: function() {
      return this.itemize(this.job.requirements)
    },
    jobType: function() {
      return this.jobTypeLabel(this.job.job_type)
    },
    workExp: function() {
      return this.expLabel(this.job.required_experience)
    },
    tags: function() {
      let t = ''
      for (let i = 0; i < this.job.tags.length; i ++) {
        if (i == this.job.tags.length - 1)
          t += this.job.tags[i].name
        else
          t += this.job.tags[i].name + ', '
      }
      return t
    },
    jobImg: function() {
      //console.log(this.job.data)
      let img = '/img/no-logo.heic',
          photo = null
      if (this.job.recruiting_company)
        photo = this.job.recruiting_company.photo
      if(photo) {
        //img = this.IMG_PREFIX + photo.path + '/' + photo.filename
        let ext = photo.filename.substr(photo.filename.lastIndexOf('.') + 1)
        img = this.IMG_PREFIX + photo.path + '/' + photo.id + '_company_photo_m.' + ext
      }
      return img
    }
  },
  methods: {
    jobListRowStyle: jobStyle.jobListRowStyle,
    isNew: function(date) {
      if (moment(date).add(7, 'day') > moment())
        return true
      return false
    },
    login: function() {
      if (!this.isLogedIn)
        window.location = this.loginUrl
    },
    applyJob: function(id) {
      if (!this.isLogedIn)
        return this.login()

      // 先获取 email
      let that = this
      const url = this.API_PREFIX + '/api/job/' + id + '/apply_email'
      
      this.$http.get(url).then(
        resp => that.$emit('apply-job', { email: resp.data.email }),
        () => that.$emit('apply-job', { email: null })
      ).catch(
        error => console.log(error)
      )
    }
  }
}
</script>